import AutomationForm from '../components/automations/Form';
import List from '../components/automations/List';
import { connect } from "react-redux";
import { addAutomation, editAutomation, fetchMyAutomation, fetchAutomationDetail, deleteAutomation } from "../store/actions/automations";
import withAuth from '../hocs/withAuth';
import { saveFile } from '../store/actions/files';
import { showLoader, hideLoader } from '../store/actions/loader';

function mapStateToProps(state, ownProps) {
  var editId = null;
  let userType = ownProps.user && ownProps.user.type;
  if (userType.includes('brand') || userType.includes('corporate')) userType = 'trainer';
  if (ownProps.match) editId = ownProps.match.params.id;
  if (ownProps.editId) editId = ownProps.editId;
  if (ownProps.workoutId) editId = ownProps.workoutId;
  return {
    errors: state.errors,
    user: state.currentUser.user,
    instructions: state.instructions[userType],
    cats: state.instructionCats,
    editId: editId,
    path: ownProps.match ? ownProps.match.path : null
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchList: (type) => {
        return dispatch(fetchMyAutomation(ownProps.user._id || localStorage.id));
    },
    fetch: (userId, param) => {
       return dispatch(fetchAutomationDetail(ownProps.user._id || localStorage.id, param));
    },
    addAutomation: (formData, user) => {

      let userType = ownProps.user.type;
      if (userType && userType.includes('trainer')) {
        userType = 'trainer';
      }
      if (userType && userType.includes('brand')) {
        userType = 'brand';
      }
      if (userType && userType.includes('corporate')) {
        userType = 'brand';
      }
      return dispatch(addAutomation({
        ...formData,
        creatorId: ownProps.user._id,
        creatorType: userType
      }, user));
    },
    deleteAutomation: (id) => {
      return dispatch(deleteAutomation(id));
    },
    edit: (editId, exercise, user) => {
      return dispatch(editAutomation(editId, exercise, user));
    },
    showLoader: () => {
      return dispatch(showLoader());
    },
    hideLoader: () => {
      return dispatch(hideLoader());
    },
  }
}
export const EditAutomation = withAuth(connect(mapStateToProps, mapDispatchToProps)(AutomationForm))
export const CreateAutomation = withAuth(connect(mapStateToProps, mapDispatchToProps)(AutomationForm))
export default withAuth(connect(mapStateToProps, mapDispatchToProps)(List))



// WEBPACK FOOTER //
// ./src/containers/Automation.js